import React, { createContext, useContext, useDebugValue, useState, useMemo } from 'react';
import NextScript from 'next/script.js';
import { useIsHubspotLoaded } from './useIsHubspotLoaded.js';

// https://github.com/vercel/next.js/issues/46078
const Script = NextScript;
const HubspotContext = createContext({
    loaded: false,
    error: false,
});
const useHubspotContext = () => {
    const values = useContext(HubspotContext);
    useDebugValue(`Hubspot Script: ${values?.loaded ? "Loaded" : "Not Loaded"}`);
    useDebugValue(`Failed to load Script: ${values?.error ? "Yes" : "No"}`);
    return values;
};
/** Loads Hubspot script to the document and syncs loading state between forms on the page */
const HubspotProvider = ({ children, id = "hubspotScript", src = "https://js.hsforms.net/forms/v2.js", strategy = "afterInteractive", ...props }) => {
    const loaded = useIsHubspotLoaded();
    const [error, setError] = useState(false);
    // Reset state when script src is changed
    // Related: https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
    const [prevSrc, setSrc] = useState(src);
    if (src !== prevSrc) {
        setSrc(src);
        setError(false);
    }
    // Prevent unnecessary rerenders
    const value = useMemo(() => ({ loaded, error }), [loaded, error]);
    return (React.createElement(HubspotContext.Provider, { value: value },
        children,
        React.createElement(Script, { id: id, src: src, strategy: strategy, ...props })));
};

export { HubspotContext, HubspotProvider, useHubspotContext };
